import { useLayoutEffect, useRef } from 'react';
import { ToggleGroup } from 'radix-ui';
import { gsap } from 'gsap';

// 21st.dev / interior.dev segmented-control interaction, MIT, adapted to the
// installed Radix primitives and GSAP instead of introducing a second motion engine.
// https://www.interior.dev/docs/segmented-control
export function SegmentedControl<T extends string>({ value, onChange, options, label }: {
  value: T; onChange: (value: T) => void; options: readonly (readonly [T, string])[]; label: string;
}) {
  const root = useRef<HTMLDivElement>(null);
  const index = Math.max(0, options.findIndex(([key]) => key === value));
  useLayoutEffect(() => {
    const media = gsap.matchMedia(root);
    media.add({ motion: '(prefers-reduced-motion: no-preference)', reduced: '(prefers-reduced-motion: reduce)' }, context => {
      gsap.to('.desk-segment-indicator', { xPercent: index * 100, duration: context.conditions?.reduced ? 0 : .24, ease: 'power3.out' });
    });
    return () => media.revert();
  }, [index]);
  return <ToggleGroup.Root ref={root} className="desk-segments" type="single" value={value} onValueChange={next => { if (next) onChange(next as T); }} aria-label={label} style={{ gridTemplateColumns: `repeat(${options.length}, minmax(0, 1fr))` }}><span className="desk-segment-indicator" aria-hidden="true" style={{ width: `calc((100% - 8px) / ${options.length})` }}/>{options.map(([key, text]) => <ToggleGroup.Item key={key} value={key}>{text}</ToggleGroup.Item>)}</ToggleGroup.Root>;
}
